import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { routerAfterEach, routerBeforeEach, routerBeforeResolve, routerConfig } from "../utils/router";

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  ...routerConfig
});

router.beforeEach(async (routeTo, routeFrom, next) => {
  await routerBeforeEach(routeTo, routeFrom, next)
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  await routerBeforeResolve(routeTo, routeFrom, next)
});

router.afterEach(async (routeTo, routeFrom) => {
  await routerAfterEach(routeTo, routeFrom)
});

export default router
